import React from 'react'

const PALETTE = ['#7C3AED', '#DB2777', '#EA580C', '#0891B2', '#16A34A', '#4F46E5', '#B45309', '#BE123C']

// Stable colour per title so the same work always gets the same placeholder
const colorFor = (title = '') => {
  let hash = 0
  for (let i = 0; i < title.length; i++) hash = (hash * 31 + title.charCodeAt(i)) >>> 0
  return PALETTE[hash % PALETTE.length]
}

const initials = (title = '') =>
  title
    .replace(/[^a-zA-Z0-9\s]/g, '')
    .split(/\s+/)
    .filter((w) => w && !['the', 'of', 'a', 'an', 'at', 'e'].includes(w.toLowerCase()))
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')

export const getWorkCoverUrl = (cover) => (cover ? `${process.env.REACT_APP_STATIC_URL}${cover}` : null)

// Cover art for a Work, or a coloured tile with its initials when none was uploaded
const WorkCover = ({ title, cover, src, size = 48, className = '' }) => {
  const url = src || getWorkCoverUrl(cover)
  const style = { width: size, height: size, minWidth: size }
  if (url) {
    return (
      <img
        src={url}
        alt={title}
        style={style}
        className={`rounded-md object-cover ${className}`}
      />
    )
  }
  return (
    <div
      style={{ ...style, background: colorFor(title), fontSize: Math.max(12, size * 0.36) }}
      className={`rounded-md flex items-center justify-center font-semibold text-white ${className}`}
      aria-label={title}
    >
      {initials(title) || '♪'}
    </div>
  )
}

// Table cell: cover, title and author
export const WorkTitleCell = ({ work, size = 36 }) => (
  <div className='flex space-x-3 items-center'>
    <WorkCover
      title={work.title}
      cover={work.cover}
      size={size}
    />
    <div className='leading-tight'>
      <div className='text-base font-medium text-neutral-800'>{work.title}</div>
      {work.author && <div className='text-xs text-neutral-500'>{work.author}</div>}
    </div>
  </div>
)

export default WorkCover
